import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { usePropertyFormContext } from "../PropertyFormProvider";

interface LayoutFooterProps {
  onCancel?: () => void;
}

export const LayoutFooter = ({ onCancel }: LayoutFooterProps) => {
  const { isSubmitting, handleSubmit, canSubmit } = usePropertyFormContext();

  return (
    <div className="flex justify-end gap-2">
      <Button
        variant={ButtonVariant.BASE}
        size={ButtonSize.SM}
        className="w-[125px]"
        onClick={onCancel}
      >
        Cancel
      </Button>
      <Button
        variant={ButtonVariant.PRIMARY}
        size={ButtonSize.SM}
        className="w-[125px]"
        type="submit"
        disabled={!canSubmit}
        onClick={handleSubmit}
        loading={isSubmitting}
      >
        Add
      </Button>
    </div>
  );
};
